import { Platform } from 'react-native';

const LOCALHOST_HOSTS = new Set(['localhost', '127.0.0.1']);
const DEFAULT_SITE_URL = 'https://perdiem.app';

function buildPlaidRedirectUri(origin: string) {
  const url = new URL(origin);
  url.pathname = '/oauth/plaid';
  url.search = '';
  url.hash = '';
  return url.toString();
}

export function getPlaidRedirectUri() {
  const configuredSiteUrl = process.env['EXPO_PUBLIC_SITE_URL']?.trim() || DEFAULT_SITE_URL;

  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    const currentOrigin = window.location.origin;
    const currentHost = window.location.hostname.toLowerCase();

    // Plaid OAuth redirect URIs must be allowlisted exactly. Use the live
    // browser origin for localhost development, but prefer the canonical site
    // origin everywhere else so preview/www hosts do not break OAuth.
    const origin = LOCALHOST_HOSTS.has(currentHost)
      ? currentOrigin
      : configuredSiteUrl;

    return buildPlaidRedirectUri(origin);
  }

  return buildPlaidRedirectUri(configuredSiteUrl);
}
